export const PETS_BUNDLE_ENABLED = typeof __GYRO_BUNDLE_PETS__ !== 'undefined' && __GYRO_BUNDLE_PETS__ === true;
export const PETS_TITLE = PETS_BUNDLE_ENABLED ? 'AI PETS' : '';
//# sourceMappingURL=companionBuild.js.map